import React from 'react';
import { capitalize } from 'lodash';
import domtoimage from 'dom-to-image';
import { pushLog2DV2LogServer } from '../services/logging';

const convertToImage = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    handleLinkImage(element);
    domtoimage.toSvg(element)
      .then(dataUrl => {
        const img = new Image();
        img.src = dataUrl;
        img.setAttribute('usemap', `#linkmap_${elementId}`);
        img.oncontextmenu = () => {
          return false;
        };
        element.innerHTML = '';
        element.appendChild(img);
      })
      .catch(function (error) {
        console.error(error);
        pushLog2DV2LogServer.error('CONVERT_2_IMAGE', 'CONVERT_2_IMAGE', {}, {}, error);
      });
  }
};

const getRoutesMapping = id => ({
  COMPLETE_PROFILE: '/dashboard/profile',
  ALGORITHM_CHALLENGE: '/dashboard/challengeintro',
  SYSTEM_DESIGN: '/dashboard/system_design',
  PROJECT_PLANNING: '/dashboard/project_planning',
  TAKE_HOME_CHALLENGE: '/dashboard/challenge'
});

// id not needed as algorithm challenge always starts with id=1
// maybe needed later when multiple types of algorithm challenges exist
const conditionNameToRoute = (conds, id = null) => {
  const routeMapping = getRoutesMapping(id);
  return (
    <ul>
      {conds.map((cnd, ind) => {
        const name = capitalize(cnd.display_name);
        return (
          <li key={`${ind}-${cnd}`}>
            <a href={routeMapping[cnd.condition_name]}>
              {name}
            </a>
          </li>
        );
      }
      )}
    </ul>
  );
};

const handlePasteEvent = (answer) => {
  const ans = document.querySelector(answer);
  const timeLeftComp = document.querySelector('.ant-statistic-content-value');
  if (!ans || !timeLeftComp) return;

  var ctrlv = false;
  if (ans) {
    ans.onkeydown = function (e) {
      var key = e.which || e.keyCode;
      var ctrl = e.ctrlKey || e.metaKey;
      if (key === 86 && ctrl) {
        ctrlv = true;
      }
    };
    ans.oninput = function (e) {
      setTimeout(function () { ctrlv = false; }, 200);
    };

    ans.onpaste = function (event) {
      const text = event.clipboardData.getData('text/plain');
      setTimeout(function () {
        const PasteType = ctrlv ? 'Keyboard' : 'Mouse';
        const TimeLeft = timeLeftComp.innerText;
        if (text.length > 15) {
          /* TODO: This 'console.log' is just to check in developer and staging environments. Remove it after that. */
          console.log('Paste Event Detected: ', { PasteType, NumCharacters: text.length, Content: text, TimeLeft });
        }
        return false;
      }, 100);
    };
  }
};

function handleLinkImage (elementParent) {
  const links = elementParent.getElementsByTagName('a');
  const elemParentRect = elementParent.getBoundingClientRect();
  const map = document.createElement('map');
  map.name = `linkmap_${elementParent.id}`;
  for (const element of links) {
    const elemRect = element.getBoundingClientRect();
    const area = document.createElement('area');
    area.alt = 'Link';
    area.shape = 'rect';
    area.target = '_blank';
    const top = (parseFloat(elemRect.top) - parseFloat(elemParentRect.top));
    const left = (parseFloat(elemRect.left) - parseFloat(elemParentRect.left));
    const right = (parseFloat(elemRect.right) - parseFloat(elemParentRect.left)) + 5;
    const bottom = (parseFloat(elemRect.bottom) - parseFloat(elemParentRect.top));
    area.coords = `${left}, ${top}, ${right}, ${bottom}`;
    area.href = element.href;
    map.appendChild(area);
  }
  elementParent.parentNode.insertBefore(map, elementParent.nextSibling);
}

export default {
  conditionNameToRoute,
  handlePasteEvent,
  convertToImage
};
